import { render, staticRenderFns } from "./Emotes.vue?vue&type=template&id=3aeed8d6&scoped=true"
import script from "./Emotes.vue?vue&type=script&lang=js"
export * from "./Emotes.vue?vue&type=script&lang=js"
import style0 from "./Emotes.vue?vue&type=style&index=0&id=3aeed8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeed8d6",
  null
  
)

export default component.exports